import ConfigCmsApi from '../configs/ConfigCmsApi';
import Cookies from 'js-cookie';

const headers = () => ({
  Authorization: Cookies.get('adminToken'),
});

const getClinicAgency = (clinicId) => ConfigCmsApi.get(`/agencies/clinic/${clinicId}`, {
  headers: headers(),
});

const linkClinicAgency = ({ agencyId, clinicId }) => ConfigCmsApi.post(`/agencies/${agencyId}/clinics/${clinicId}/link`, {}, {
  headers: headers(),
});

const unlinkClinicAgency = ({ agencyId, clinicId }) => ConfigCmsApi.delete(`/agencies/${agencyId}/clinics/${clinicId}/link`, {
  headers: headers(),
});

export default {
  getClinicAgency,
  linkClinicAgency,
  unlinkClinicAgency,
};
